import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from './modules/core/core.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgApexchartsModule } from 'ng-apexcharts';
import { MatTabsModule } from '@angular/material/tabs';
import { AutologinComponent } from './autologin.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    AppComponent,
    AutologinComponent,
  ],
  imports: [
    BrowserModule,
    MatTabsModule,
    AppRoutingModule,
    NgApexchartsModule,
    BrowserAnimationsModule,
    CoreModule,
    NgxSpinnerModule.forRoot({
      type: 'ball-scale-multiple',
    }),
    RouterModule.forRoot([
      //não precisa estar logado para acessar essa rota
      {
        path: 'autologin/:token',
        component: AutologinComponent,
        pathMatch: 'full',
      },
    ]),

  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {
}
